<template>
  <div
    class="modal fade"
    id="kpiAssignmentDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="kpiAssignmentDialogForm">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.KM1000 }}</b>
            </h4>
            <p>
              <b>{{ lang.KM1001 }}:</b>
              {{ nameOfSelectedClient }}
              <b>/ {{ lang.KM1013 }}:</b>
              {{ nameOfSelectedProject }}
              <b>/ {{ lang.KM1002 }}:</b>
              {{ nameOfSelectedKpiGroup }}
              <b>/ {{ lang.KM1003 }}:</b>
              {{ nameOfselectedEvaluationRuleGuid }}
            </p>
          </div>
          <div class="modal-body">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="col-md-6" style="padding-left: 0">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label
                        for="KPIAssignmentModalClientSelect"
                        class="col-md-3 control-label"
                        >{{ lang.KM1004 }}</label
                      >
                      <div class="col-md-9">
                        <select2
                          class="form-control"
                          id="KPIAssignmentModalClientSelect"
                          v-model="selectedClientGuid"
                          :key="selectedClientGuid"
                          :afterChange="selectedClientGuidChanged"
                          :disabled="
                            feature.isAudiTarget &&
                            feature.isEnabled('audi_importers')
                          "
                        >
                          <option
                            v-for="client in clientList"
                            :key="client.ClientGuid"
                            :value="client.ClientGuid"
                          >
                            {{ client.ClientName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="KPIAssignmentModalKpiGroupSelect"
                        class="col-md-3 control-label"
                        >{{ lang.KM1005 }}</label
                      >
                      <div class="col-md-9">
                        <select2
                          class="form-control"
                          id="KPIAssignmentModalKpiGroupSelect"
                          v-model="selectedKpiGroupGuid"
                          :key="selectedKpiGroupGuid"
                          :placeholder="lang.KM1006"
                          :disabled="kpiGroupsOfSelectedClient.length < 1"
                          :afterChange="selectedKpiGroupGuidChanged"
                        >
                          <option
                            v-for="kpiGroup in kpiGroupsOfSelectedClient"
                            :key="kpiGroup.KPIGroupGuid"
                            :value="kpiGroup.KPIGroupGuid"
                          >
                            {{ kpiGroup.KPIGroupCode }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="KPIAssignmentModalKpiSelect"
                        class="col-md-3 control-label"
                        >{{ lang.KM1007 }}</label
                      >
                      <div class="col-md-9">
                        <select2
                          class="form-control"
                          id="KPIAssignmentModalKpiSelect"
                          v-model="selectedKpiGuid"
                          :key="selectedKpiGuid"
                          :placeholder="lang.KM1008"
                          :disabled="kpisOfSelectedKpiGroup.length < 1"
                          :afterChange="selectedKpiGuidChanged"
                        >
                          <option
                            v-for="kpi in kpisOfSelectedKpiGroup"
                            :key="kpi.KPIGuid"
                            :value="kpi.KPIGuid"
                          >
                            {{ kpi.KPICode }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-raised btn-top-bar"
                      :class="{ 'btn-warning': treeViewChanged }"
                      :disabled="!treeViewChanged || !selectedKpiGuid"
                      @click="saveKpiQuestionAssignmentData()"
                    >
                      <i class="material-icons md-36">save</i>
                      <br />
                      {{ lang.KM1012 }}
                    </button>
                  </form>
                </div>
                <div class="col-md-6" style="padding-right: 0">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label
                        for="KPIAssignmentModalSurveySelect"
                        class="col-md-3 control-label"
                        >{{ lang.KM1010 }}</label
                      >
                      <div class="col-md-9">
                        <select2
                          class="form-control"
                          id="KPIAssignmentModalSurveySelect"
                          v-model="selectedSurveyGuid"
                          :key="selectedSurveyGuid"
                          :placeholder="lang.KM1011"
                          :disabled="surveysFromSelectedKpiGroup.length < 1"
                          :afterChange="selectedSurveyGuidChanged"
                        >
                          <option
                            v-for="survey in surveysFromSelectedKpiGroup"
                            :key="survey.SurveyGuid"
                            :value="survey.SurveyGuid"
                          >
                            {{ survey.SurveyId }} - {{ survey.SurveyTitle }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="well" id="liquortreeContainerWell">
                      <liquortree
                        v-if="showTree"
                        :data="treeData"
                        :options="treeOptions"
                        ref="kpiQuestionAssignmentTree"
                      >
                        <span class="tree-text" slot-scope="{ node }">
                          <template v-if="!node.data.IsCluster">
                            <div
                              class="checkbox"
                              style="margin: 0px; padding-top: 3px"
                            >
                              <label>
                                <input
                                  type="checkbox"
                                  @change="toggleQuestionCheckbox(node)"
                                  :checked="node.checked()"
                                />
                                <span class="checkbox-material">
                                  <span class="check"></span>
                                </span>
                                <span class="ltree-types-and-points"
                                  >({{
                                    convertQuestionTypeToLetter(node.data.Type)
                                  }}|{{
                                    node.data.PointsMax
                                      ? node.data.PointsMax
                                      : 0
                                  }})</span
                                >
                                <span
                                  :id="node.data.QuestionGuid"
                                  class="text-black"
                                  >{{ node.text }}</span
                                >
                                <b-tooltip
                                  ref="tooltip"
                                  :target="node.data.QuestionGuid"
                                  :delay="globals.tooltipDelay"
                                  >{{ node.text }}</b-tooltip
                                >
                              </label>
                            </div>
                          </template>
                          <template v-else>
                            <i class="material-icons">{{
                              node.checked() || node.indeterminate()
                                ? "folder"
                                : "folder_open"
                            }}</i>
                            <span :id="node.data.PanelGuid">{{
                              node.text
                            }}</span>
                            <b-tooltip
                              ref="tooltip"
                              :target="node.data.PanelGuid"
                              :delay="globals.tooltipDelay"
                              >{{ node.text }}</b-tooltip
                            >
                          </template>
                        </span>
                      </liquortree>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.KM1009 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import LiquorTree from "liquor-tree";
import Select2 from "../Tools/Select2";

export default {
  name: "KpiQuestionAssignmentModal",
  components: { liquortree: LiquorTree, Select2 },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#kpiAssignmentDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
  },
  props: [
    "showDialog",
    "clientList",
    "selectedClientFromParent",
    "selectedKpiData",
    "kpiEvaluationRulesList",
    "kpiGroupEvaluationRulesList",
    "projectList",
  ],
  watch: {
    showDialog() {
      this.showDialog
        ? this.openKpiAssignmentDialog()
        : this.closeKpiAssignmentDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      selectedClientGuid: "",
      kpiGroupsOfSelectedClient: [],
      selectedKpiGroupGuid: "",
      kpisOfSelectedKpiGroup: [],
      selectedKpiGuid: "",
      selectedKpi: {},
      surveysFromSelectedKpiGroup: [],
      selectedSurveyGuid: "",
      treeData: [],
      showTree: false,
      treeViewChanged: false,
      treeOptions: {
        parentSelect: true,
        deletion(node) {
          return node.checked();
        },
      },
      lang: {
        KM1000: "KPI – Question Assignment",
        KM1001: "Client",
        KM1002: "KPI Group",
        KM1003: "Evaluation rule",
        KM1004: "Client",
        KM1005: "KPI Group",
        KM1006: "Please select a KPI Group...",
        KM1007: "KPI",
        KM1008: "Please select a KPI...",
        KM1009: "Close",
        KM1010: "Survey",
        KM1011: "Please select a survey...",
        KM1012: "Save",
        KM1013: "Project",
      },
    };
  },
  computed: {
    nameOfSelectedClient() {
      if (!this.selectedClientGuid) return " - ";
      let client = this.clientList.find(
        (c) => c.ClientGuid === this.selectedClientGuid
      );
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup() {
      if (!this.selectedKpiGroupGuid) return " - ";
      let kpiGroup = this.kpiGroupsOfSelectedClient.find(
        (element) => element.KPIGroupGuid === this.selectedKpiGroupGuid
      );
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfselectedEvaluationRuleGuid() {
      if (!this.selectedKpiGroupGuid) return " - ";
      let evaluationRule;
      let kpi = this.kpisOfSelectedKpiGroup.find(
        (el) => el.KPIGuid === this.selectedKpiGuid
      );
      if (kpi && kpi.KPIEvaluationRuleGuid) {
        evaluationRule = this.kpiEvaluationRulesList.find(
          (el) => el.EvaluationRuleGuid === kpi.KPIEvaluationRuleGuid
        );
        return evaluationRule.EvaluationRule;
      }

      let kpiGroup = this.kpiGroupsOfSelectedClient.find(
        (element) => element.KPIGroupGuid === this.selectedKpiGroupGuid
      );
      if (kpiGroup)
        evaluationRule = this.kpiGroupEvaluationRulesList.find(
          (element) =>
            element.EvaluationRuleGuid === kpiGroup.KPIEvaluationRuleGuid
        );
      return evaluationRule ? evaluationRule.EvaluationRule : " - ";
    },
    nameOfSelectedProject() {
      if (!this.selectedKpiGroupGuid || !this.selectedClientGuid) return " - ";
      let kpiGroup = _.find(this.kpiGroupsOfSelectedClient, [
        "KPIGroupGuid",
        this.selectedKpiGroupGuid,
      ]);
      let projectGuid, projectName;
      if (
        kpiGroup &&
        kpiGroup.Projects &&
        kpiGroup.Projects[0] &&
        kpiGroup.Projects[0].ProjectGuid
      )
        projectGuid = kpiGroup.Projects[0].ProjectGuid;

      if (projectGuid) {
        let clientProjects = _.find(this.projectList, [
          "ClientGuid",
          this.selectedClientGuid,
        ]);
        if (
          clientProjects &&
          clientProjects.Projects &&
          clientProjects.Projects.length > 0
        ) {
          let projectData = _.find(clientProjects.Projects, [
            "ProjectGuid",
            projectGuid,
          ]);
          if (projectData && projectData.ProjectName)
            projectName = projectData.ProjectName;
        }
      }
      if (projectName) return projectName;
      return " - ";
    },
    selectedSurvey() {
      return this.surveysFromSelectedKpiGroup.find(
        (survey) => survey.SurveyGuid === this.selectedSurveyGuid
      );
    },
  },
  methods: {
    selectedSurveyGuidChanged() {
      this.getSelectedSurvey();
    },
    selectedKpiGuidChanged() {
      this.getKpiSurveyAssignment();
    },
    selectedKpiGroupGuidChanged() {
      this.getKpiInformation(true);
    },
    selectedClientGuidChanged() {
      this.getKpiGroupsOfSelectedClient(true);
    },
    openKpiAssignmentDialog() {
      $("#kpiAssignmentDialog").modal("show");
      this.initKpiAssignmentDialog();
      this.getKpiGroupsOfSelectedClient();
    },
    closeKpiAssignmentDialog() {
      $("#kpiAssignmentDialog").modal("hide");
    },
    initKpiAssignmentDialog() {
      this.selectedClientGuid = "";
      if (this.selectedClientFromParent)
        this.selectedClientGuid = this.selectedClientFromParent;

      this.selectedKpiGroupGuid = "";
      this.selectedKpiGuid = "";
      this.selectedSurveyGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.surveysFromSelectedKpiGroup = [];
      this.treeData = [];
      this.showTree = false;
      this.treeViewChanged = false;
    },
    getKpiGroupsOfSelectedClient(changed) {
      this.selectedKpiGroupGuid = "";
      if (changed) {
        this.selectedKpiGuid = "";
        this.selectedSurveyGuid = "";
      }
      this.surveysFromSelectedKpiGroup = [];
      this.kpisOfSelectedKpiGroup = [];
      this.treeData = [];
      this.reloadTreeView();

      let queryString = `api/KPIGroups/Client/${this.selectedClientGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpiGroupsOfSelectedClient = !_.isEmpty(data) ? data : [];
          this.sortKpiGroupsByKpiCode();
          if (!changed && !_.isEmpty(this.selectedKpiData)) {
            this.$nextTick(() => {
              this.selectedKpiGroupGuid =
                this.selectedKpiData.KPIGroups[0].KPIGroupGuid;
              this.getKpiInformation();
            });
          }
        },
        error: () => {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          this.globals.showErrorSnackbar("KPI Group request failed");
        },
      });
    },
    sortKpiGroupsByKpiCode() {
      this.kpiGroupsOfSelectedClient.sort((a, b) => {
        if (a.KPIGroupCode.toLowerCase() < b.KPIGroupCode.toLowerCase())
          return -1;
        if (a.KPIGroupCode.toLowerCase() > b.KPIGroupCode.toLowerCase())
          return 1;
        return 0;
      });
    },
    getKpiInformation(changed) {
      this.treeData = [];
      this.reloadTreeView();
      if (this.selectedKpiGroupGuid) {
        this.getKpisOfSelectedKpiGroup(changed);
        this.getSurveysFromSelectedKpiGroup();
      }
    },
    getKpisOfSelectedKpiGroup(changed) {
      if (!this.selectedKpiGroupGuid) return;
      this.selectedKpiGuid = "";
      let queryString = `api/KPIGroups/${this.selectedKpiGroupGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.kpisOfSelectedKpiGroup = data[0].KPIs || [];
          this.sortKpisByKpiCode();

          if (!changed && !_.isEmpty(this.selectedKpiData))
            this.$nextTick(() => {
              this.selectedKpiGuid = this.selectedKpiData.KPIGuid;
              this.getKpiSurveyAssignment();
            });
        },
        error: () => {
          console.error("Error on GET in getKpisOfSelectedKpiGroup()");
          this.globals.showErrorSnackbar("KPI data request failed");
        },
      });
    },
    sortKpisByKpiCode() {
      this.kpisOfSelectedKpiGroup.sort((a, b) => {
        if (a.KPICode.toLowerCase() < b.KPICode.toLowerCase()) return -1;
        if (a.KPICode.toLowerCase() > b.KPICode.toLowerCase()) return 1;
        return 0;
      });
    },
    getSurveysFromSelectedKpiGroup() {
      if (!this.selectedKpiGroupGuid) return;
      let getString = `api/KPIGroups/${this.selectedKpiGroupGuid}/Data/SurveyQuestions`;

      $.ajax({
        method: "GET",
        url: getString,
        success: (data) => {
          this.surveysFromSelectedKpiGroup = !_.isEmpty(data) ? data : [];
          this.sortSurveysBySurveyTitle();
        },
        error: () => {
          console.error(
            "Survey data request failed in getSurveysFromSelectedKpiGroup()"
          );
          this.globals.showErrorSnackbar("Survey data request failed");
        },
      });
    },
    sortSurveysBySurveyTitle() {
      this.surveysFromSelectedKpiGroup.sort((a, b) => {
        if (a.SurveyTitle.toLowerCase() < b.SurveyTitle.toLowerCase())
          return -1;
        if (a.SurveyTitle.toLowerCase() > b.SurveyTitle.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiSurveyAssignment() {
      if (!this.selectedKpiGuid) {
        this.selectedKpi.SurveyQuestions = [];
        return;
      }
      let getString = `api/KPIs/${this.selectedKpiGuid}`;

      $.ajax({
        method: "GET",
        url: getString,
        success: (data) => {
          if (!_.isEmpty(data)) {
            this.selectedKpi = data[0];
            if (!this.selectedKpi.SurveyQuestions)
              this.selectedKpi.SurveyQuestions = [];
          } else this.selectedKpi = {};
          this.getSelectedSurvey();
        },
        error: () => {
          console.error(
            "Assignment data request failed in getKpiSurveyAssignment()"
          );
          this.globals.showErrorSnackbar("Assignment data request failed");
        },
      });
    },
    getSelectedSurvey() {
      this.treeData = [];
      this.reloadTreeView();
      this.treeViewChanged = false;
      if (this.selectedSurveyGuid && this.selectedKpiGuid) {
        this.generateTreeDataFromSurvey(this.selectedSurvey);
      }
    },
    // generate the json string for liquor tree from received survey of a selected kpi group
    generateTreeDataFromSurvey(selectedSurvey) {
      if (!selectedSurvey || !selectedSurvey.Panel) return;
      let surveyCluster = selectedSurvey.Panel;
      this.treeData = surveyCluster.map((surveyElement) => {
        let node = {};
        node.data = surveyElement;
        node.text = surveyElement.Title;
        if (surveyElement.Questions)
          node.children = surveyElement.Questions.map((question) => {
            let child = {};
            child.data = question;
            child.text = question.Title;
            return child;
          });
        return node;
      });
      if (this.selectedKpi.SurveyQuestions)
        this.setCheckedSurveyQuestions(this.selectedKpi.SurveyQuestions);
      this.reloadTreeView();
    },
    setCheckedSurveyQuestions(surveyQuestions) {
      let checkedQuestions = surveyQuestions.filter(
        (survey) => survey.SurveyGuid === this.selectedSurveyGuid
      );
      if (checkedQuestions.length === 0) return;
      let questions = checkedQuestions[0].Questions;
      if (!questions) return;
      this.treeData.forEach((treeElement) => {
        if (treeElement.children) {
          questions.forEach((question) => {
            let node = treeElement.children.find(
              (child) => child.data.QuestionGuid === question.QuestionGuid
            );
            if (node)
              node.state = {
                checked: true,
              };
          });
        }
      });
    },
    reloadTreeView() {
      this.showTree = false;
      this.$nextTick(() => {
        this.showTree = true;
      });
    },
    toggleQuestionCheckbox(node) {
      this.treeViewChanged = true;
      node.checked() ? node.uncheck() : node.check();
    },
    getCheckedSurveyQuestions() {
      let tree = this.$refs.kpiQuestionAssignmentTree;
      if (!tree) return;
      let idx = this.selectedKpi.SurveyQuestions.findIndex(
        (element) => element.SurveyGuid === this.selectedSurveyGuid
      );
      let selection = tree.findAll({ state: { checked: true } });
      let questions = [];
      if (selection) {
        selection.forEach((element) => {
          if (!element.data.IsCluster) {
            questions.push({
              QuestionGuid: element.data.QuestionGuid,
              QuestionTitle: element.text,
            });
          }
        });
        if (idx === -1) {
          let newSurveyQuestion = {
            SurveyGuid: this.selectedSurveyGuid,
            SurveyTitle: this.selectedSurvey.SurveyTitle,
            Questions: questions,
          };
          this.selectedKpi.SurveyQuestions.push(newSurveyQuestion);
        } else this.selectedKpi.SurveyQuestions[idx].Questions = questions;
      } else this.selectedKpi.SurveyQuestions.splice(idx, 1);
    },
    saveKpiQuestionAssignmentData() {
      let queryString = `api/KPIs/${this.selectedKpiGuid}`;
      this.getCheckedSurveyQuestions();

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.selectedKpi),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data[0] && data[0].error) {
            console.error(data[0].error);
            this.globals.showErrorSnackbar(data[0].error);
            return;
          }
          this.globals.showSuccessSnackbar("Assignment data update successful");
          this.treeViewChanged = false;
        },
        error: () => {
          console.error(
            "Assignment data update failed in saveKpiQuestionAssignmentData()"
          );
          this.globals.showErrorSnackbar("Assignment data update failed");
        },
      });
    },
    convertQuestionTypeToLetter(type) {
      if (!type) return "";
      switch (type) {
        case "checkbox":
          return "M";
        case "radiogroup":
          return "S";
        case "dropdown":
          return "D";
        case "rating":
          return "R";
        default:
          return "";
      }
    },
  },
};
</script>

<style>
#liquortreeContainerWell .tree-children .checkbox label {
  font-size: 14px;
}
#liquortreeContainerWell a:hover,
#liquortreeContainerWell a:focus {
  text-decoration: none;
  color: #23527c;
}
</style>

<style scoped>
.modal-lg {
  width: calc(100vw - 450px);
}

.modal-content {
  background-color: #eee;
}

.well {
  background-color: #ffffff;
  height: calc(100vh - 350px);
  overflow: auto;
  margin: 15px;
}

.well > .tree {
  overflow: hidden;
}

.tree-checkbox {
  width: 20px;
  height: 20px;
}

.btn-top-bar.btn.btn-raised.btn-warning {
  background-color: #ff5722;
}

.btn.btn-raised.btn-warning:hover {
  background-color: #ec5122ab;
}

.modal-footer .btn-default {
  background: rgb(190, 190, 190);
}

#kpiAssignmentDialog .form-horizontal .form-group {
  margin: 0;
}

.ltree-types-and-points {
  padding: 0 5px 0 5px;
  font-weight: bold;
  color: black;
}

.tree-text .material-icons {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// KPIAssignmentModal.vue?df29e374